import { Component, ElementRef } from '@angular/core';
import { MappingPaymentComponent } from 'app/private/paymentGateways/mapping/mapping.payment.component';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';
import { MappingSources } from 'app/infrastructure/model/enum/mappingSources.enum';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { AttributeReference, AttributeChangeEventArgsType, OptionsAttribute, RuleAttribute, PageNavigationAttribute, ModalTextAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
    selector: 'sx-redirectPG-designer',
    templateUrl: './redirectPaymentGateway.component.html'
})

export class SxRedirecPGDesigner extends BaseDesignerComponent {

    pageList: DesignerSelectItem[] = [];
    interactionRules: DesignerSelectItem[] = [];

    constructor(container: ElementRef,
        private sxTranslationService: SxTranslationService,
        private srvPayment: PaymentGatewayService) {
        super(container, 'SxRedirectPG');
    }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.paymentGatewayCode = '';
        this.controlContext.selectedOptionRule = '';
        this.controlContext.actionType = 'navigation';
        this.controlContext.ruleValue = '';
        this.controlContext.onSuccess = '';
        this.controlContext.onError = '';
        this.controlContext.amount = '';
        this.controlContext.amountMapping = MappingSources.documentAttributes;
        this.controlContext.mapping = '[]';
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();
        info['paymentGatewayCode'] = this.controlContext.paymentGatewayCode;
        info['actionType'] = this.controlContext.actionType;
        info['ruleValue'] = this.controlContext.ruleValue;
        info['onSuccess'] = this.controlContext.onSuccess;
        info['onError'] = this.controlContext.onError;
        info['amount'] = this.controlContext.amount;
        info['amountMapping'] = this.controlContext.amountMapping;
        info['mapping'] = this.controlContext.mapping;        
        info['amountMappingTo'] = this.controlContext.amountMappingTo;        
        info['amountMappingFrom'] = this.controlContext.amountMappingFrom;        

        return info;
    }

    buildAttributes(): void {
        super.buildAttributes();

        this.pageList = this.designerContext.product.pageList;
        this.pageList.forEach(element => {
            element.description = element.id;
        })        
        
        this.interactionRules = this.designerContext.product.interactionRules;

        const paycodes = this.designerContext.product.pgCodes;
        const paymentGatewayCode = new AttributeReference(this.controlContext, paycodes, 'paymentGatewayCode', 'PAYMENT_GATEWAY_CODE');
        paymentGatewayCode.change.subscribe(v => this.onPgCodeChange(v)); 
        this.onPgCodeChange(new AttributeChangeEventArgsType (null , this.controlContext.paymentGatewayCode, null));    

        const actionTypeOptions = [
            { id: 'executeRule', name: 'ExecuteRule' },
            { id: 'navigation', name: 'Navigation' }
        ];

        const amountOptions = [
            { id: MappingSources.totalAward, description: this.sxTranslationService.getResource('TOTAL_AWARD') },
            { id: MappingSources.firstInstallment, description: this.sxTranslationService.getResource('FIRST_INSTALLMENT') },
            { id: MappingSources.documentAttributes, description: this.sxTranslationService.getResource('DOCUMENT_ATTRIBUTES') },
        ];

        const actionType = new OptionsAttribute(this.controlContext, actionTypeOptions, 'actionType', 'ACTION_TYPE');

        const ruleValue = new RuleAttribute(this.controlContext, this.interactionRules, 'ruleValue', 'RULE_VALUE');
        ruleValue.hiddenConditions = [
            ['actionType', '!=', 'executeRule'],
        ];

        const onSuccess = new PageNavigationAttribute(this.controlContext, this.pageList, 'onSuccess', 'ON_SUCCESS');
        onSuccess.hiddenConditions = [
            ['actionType', '!=', 'navigation']
        ];

        const onError = new PageNavigationAttribute(this.controlContext, this.pageList, 'onError', 'ON_ERROR');
        onError.hiddenConditions = [
            ['actionType', '!=', 'navigation']
        ];

        const amount = new OptionsAttribute(this.controlContext, amountOptions, 'amount', 'AMOUNT');

        const amountMappingTo = new AttributeReference(this.controlContext, [],
            'amountMappingTo', 'PAYMENT_GATEWAY_AMOUNT_CODATT');
        amountMappingTo.hiddenConditions = [
            ['amount', '!=', MappingSources.documentAttributes.toString()]
        ];

        const flowattrs = this.designerContext.product.attributeCodes;
        
        const amountMappingFrom = new AttributeReference(this.controlContext, flowattrs,
            'amountMappingFrom', 'FLOW_AMOUNT_CODATT');
        amountMappingFrom.hiddenConditions = [
            ['amount', '!=', MappingSources.documentAttributes.toString()]
        ];

        const mapping = new ModalTextAttribute(this.controlContext, 'mapping', MappingPaymentComponent, 'MAPPING');

        this.attributes.push(
            paymentGatewayCode,
            actionType,
            ruleValue,
            onSuccess,
            onError,
            amount,
            amountMappingTo,
            amountMappingFrom,
            mapping);
    }

    onPgCodeChange(args: AttributeChangeEventArgsType): void {
        if (args.newValue != '' && this.designerContext.selectedDesignerAtts.length != 0) {
            const modalconfig = (this.designerContext.selectedDesignerAtts.find(y => y.name === 'mapping') as ModalTextAttribute);
            const params : string[]= 
            [   
                this.designerContext.product.codSistema,
                this.designerContext.product.codNegocio,
                this.designerContext.product.codProducto,
                this.designerContext.product.documentKind,
                args.newValue
            ];
            modalconfig.setParameters(params);
            this.srvPayment.getAttributes(this.designerContext.product.codSistema, args.newValue)
                .subscribe(x => {
                    const amountMappingTo = (this.designerContext.selectedDesignerAtts.find(y => y.name === 'amountMappingTo') as AttributeReference);
                    amountMappingTo.options = x;
                    amountMappingTo.options = amountMappingTo.options.data;                                 
                })
        }
    }  
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/redirectPaymentGateway.component.ts